import { useState } from "react";
import type { QuickAction } from "../api/types";
import { useCharacter } from "../character";
import { text } from "../text";
import { Sheet } from "./Sheet";

/** Large touch targets for frequent career actions; inputs open in a sheet, actions without inputs run directly. */
export function QuickActions(props: { actions?: QuickAction[] }) {
  const { character, apply, language } = useCharacter();
  const actions = props.actions ?? character.quickActions;
  const [open, setOpen] = useState<QuickAction | null>(null);
  const [values, setValues] = useState<Record<string, string>>({});

  if (actions.length === 0) return null;

  const run = async (action: QuickAction, inputs: Record<string, string>) => {
    const payload: Record<string, unknown> = { ...(action.payload as Record<string, unknown>) };
    for (const input of action.inputs ?? []) {
      const raw = inputs[input.field] ?? (input.default != null ? String(input.default) : "");
      payload[input.field] = input.kind === "number" ? Number(raw.replace(",", ".")) : raw;
    }
    if (await apply({ type: action.operation, payload })) setOpen(null);
  };

  return (
    <>
      <div className="quick-actions">
        {actions.map((action) => (
          <button
            key={action.id}
            type="button"
            className="quick-action"
            onClick={() => {
              if ((action.inputs ?? []).length === 0) void run(action, {});
              else {
                setValues({});
                setOpen(action);
              }
            }}
          >
            {text(action.label, language)}
          </button>
        ))}
      </div>
      {open && (
        <Sheet
          title={text(open.label, language)}
          onClose={() => setOpen(null)}
          footer={
            <button type="button" className="button primary" onClick={() => void run(open, values)}>
              Buchen
            </button>
          }
        >
          {(open.inputs ?? []).map((input) => (
            <label key={input.field} className="field">
              <span>{text(input.label, language)}</span>
              <input
                type={input.kind === "number" ? "text" : "text"}
                inputMode={input.kind === "number" ? "decimal" : "text"}
                autoFocus={input === open.inputs?.[0]}
                value={values[input.field] ?? ""}
                onChange={(e) => setValues({ ...values, [input.field]: e.target.value })}
              />
            </label>
          ))}
        </Sheet>
      )}
    </>
  );
}
